import { InjectionToken } from '@angular/core';

export interface Environment {
  production: boolean;
  apiUrl: string;
  apiPath: string;
  frontendUrl: string;
  elmtPollingInterval: number;
  lmsUrl?: string;
}

export const environmentToken = new InjectionToken<Environment>('environment-token');
